// @flow

import { getPdbItem } from './main';
import type { State } from '../types';

type GlobalState = {
  pdb: State,
};

export const hasVbmr = (
  state: GlobalState,
  pdbId: ?string = null,
): boolean => {
  const pdbItem = getPdbItem(state, pdbId);
  if (pdbItem.model && pdbItem.model.hasVBMR) {
    return pdbItem.model.hasVBMR;
  }
  return false;
};

export default null;
